// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getSymbolsDummyData = () => {
    return [
        {
            InstName: "FUTIDX",
            Symbol: "NIFTY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "18214.05",
            PricePerChange: "1.50948548753845",
            OIPerChange: "3.59066271465211",
            SharesRolled: "1565600",
            ROPer: "11.5963068991952",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.334631781509333",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20559",
            CompanyName: "NIFTY 50",
        },
        {
            InstName: "FUTIDX",
            Symbol: "BANKNIFTY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "42862.1",
            PricePerChange: "1.18889951249454",
            OIPerChange: "-3.36027357979588",
            SharesRolled: "279100",
            ROPer: "10.9280631172975",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.380056040184689",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "26753",
            CompanyName: "NIFTY BANK",
        },
        {
            InstName: "FUTIDX",
            Symbol: "FINNIFTY",
            ExpDate: "1/31/2023 12:00:00 AM",
            CurrPrice: "18890.55",
            PricePerChange: "0.992790639860789",
            OIPerChange: "24.4444444444444",
            SharesRolled: "760",
            ROPer: "3.28151986183074",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.866570851563352",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "41384",
            CompanyName: "NIFTY FINANCIAL SERVICES",
        },
        {
            InstName: "FUTSTK",
            Symbol: "COFORGE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4001",
            PricePerChange: "3.60990263103377",
            OIPerChange: "-6.74603174603175",
            SharesRolled: "36000",
            ROPer: "6.79886685552408",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.806048487878031",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "24978",
            CompanyName: "COFORGE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PERSISTENT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3966",
            PricePerChange: "3.5225329870401",
            OIPerChange: "0.4903809883063",
            SharesRolled: "22050",
            ROPer: "4.51612903225806",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.329046898638431",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18286",
            CompanyName: "PERSISTENT SYSTEMS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "L&TFH",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "90.3",
            PricePerChange: "3.49570200573066",
            OIPerChange: "0.161124945071041",
            SharesRolled: "2043596",
            ROPer: "3.24041318805717",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.498338870431897",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "41147",
            CompanyName: "L&T FINANCE HOLDINGS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "M&M",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1315.15",
            PricePerChange: "3.45736312146004",
            OIPerChange: "10.085860838537",
            SharesRolled: "221200",
            ROPer: "1.57519565325756",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.330760749724359",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "365",
            CompanyName: "MAHINDRA & MAHINDRA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TECHM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1021.3",
            PricePerChange: "3.21896002829854",
            OIPerChange: "-5.41688293304393",
            SharesRolled: "504000",
            ROPer: "4.02202537706488",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.626652305884666",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "17215",
            CompanyName: "TECH MAHINDRA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TCS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3310",
            PricePerChange: "3.06710260003114",
            OIPerChange: "2.92145089364093",
            SharesRolled: "283325",
            ROPer: "2.68753838747697",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.528700906344411",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5400",
            CompanyName: "TATA CONSULTANCY SERV LT",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BSOFT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "293.4",
            PricePerChange: "3.03775241439859",
            OIPerChange: "-2.0743104627308",
            SharesRolled: "384000",
            ROPer: "4.27807486631016",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.443081117927748",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "16541",
            CompanyName: "BIRLASOFT LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LAURUSLABS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "385.45",
            PricePerChange: "2.86896183613558",
            OIPerChange: "-0.334950334950335",
            SharesRolled: "568700",
            ROPer: "5.65274436912311",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.959916980153065",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "45955",
            CompanyName: "LAURUS LABS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BHARTIARTL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "822.25",
            PricePerChange: "2.7940992624078",
            OIPerChange: "0.275321004799844",
            SharesRolled: "1041200",
            ROPer: "2.59396004922844",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.498631802979632",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "15542",
            CompanyName: "BHARTI AIRTEL LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HCLTECH",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1054.3",
            PricePerChange: "2.71823850350739",
            OIPerChange: "4.64069532826323",
            SharesRolled: "201600",
            ROPer: "2.09119953528899",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.626007777672402",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5656",
            CompanyName: "HCL TECHNOLOGIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HINDCOPPER",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "119.5",
            PricePerChange: "2.66323024054982",
            OIPerChange: "3.31310065756196",
            SharesRolled: "806400",
            ROPer: "3.95015283329415",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.376569037656906",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3898",
            CompanyName: "HINDUSTAN COPPER LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATAMOTORS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "394.25",
            PricePerChange: "2.64254100494662",
            OIPerChange: "-1.28460353829396",
            SharesRolled: "4675425",
            ROPer: "5.87540067689773",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.279010779961959",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "560",
            CompanyName: "TATA MOTORS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INFY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1493.85",
            PricePerChange: "2.63130775308302",
            OIPerChange: "5.00697637182918",
            SharesRolled: "1610400",
            ROPer: "4.2006635921621",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.465240820698199",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2806",
            CompanyName: "INFOSYS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "WIPRO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "391.75",
            PricePerChange: "2.60607647983237",
            OIPerChange: "-1.01215997750756",
            SharesRolled: "3201000",
            ROPer: "7.04290429042904",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.48500319081046",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "614",
            CompanyName: "WIPRO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INTELLECT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "434.35",
            PricePerChange: "2.48938178386031",
            OIPerChange: "0.891304347826087",
            SharesRolled: "80000",
            ROPer: "1.69455623808515",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.759755957177381",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "54769",
            CompanyName: "INTELLECT DESIGN ARENA",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NATIONALUM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "83.3",
            PricePerChange: "2.39704978488015",
            OIPerChange: "1.43546035662218",
            SharesRolled: "2850000",
            ROPer: "4.03183023872679",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.24009603841537",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2304",
            CompanyName: "NATIONAL ALUMINIUM CO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CANFINHOME",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "558.05",
            PricePerChange: "2.34754699679045",
            OIPerChange: "2.70766406608536",
            SharesRolled: "85800",
            ROPer: "1.92813321647677",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.645103485350779",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1223",
            CompanyName: "CAN FIN HOMES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MANAPPURAM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "121.9",
            PricePerChange: "2.30801510700797",
            OIPerChange: "-0.365678464150451",
            SharesRolled: "2172000",
            ROPer: "4.5300963584032",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.205086136177194",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "6083",
            CompanyName: "MANAPPURAM FINANCE LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDUSINDBK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1215.45",
            PricePerChange: "2.26756415649979",
            OIPerChange: "-0.523409086535686",
            SharesRolled: "413100",
            ROPer: "1.74481592001977",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.448393599078534",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5531",
            CompanyName: "INDUSIND BANK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HINDALCO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "473",
            PricePerChange: "2.23711228790663",
            OIPerChange: "0.23775261215041",
            SharesRolled: "474600",
            ROPer: "2.0721271393643",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.401691331923885",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "252",
            CompanyName: "HINDALCO  INDUSTRIES  LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "RELIANCE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2605.05",
            PricePerChange: "2.11277267114831",
            OIPerChange: "0.245004267341593",
            SharesRolled: "546250",
            ROPer: "1.57836947570683",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.47791789025162",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "476",
            CompanyName: "RELIANCE INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HDFCAMC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2182.8",
            PricePerChange: "2.07631874298541",
            OIPerChange: "-1.91616766467066",
            SharesRolled: "98400",
            ROPer: "5.41164824286421",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.054975261132482",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "21272",
            CompanyName: "HDFC AMC LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "FSL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "103.6",
            PricePerChange: "2.06896551724137",
            OIPerChange: "-1.60708428993112",
            SharesRolled: "910000",
            ROPer: "5.51181102362205",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.530888030888042",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "24882",
            CompanyName: "FIRSTSOURCE SOLU. LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "METROPOLIS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1365.15",
            PricePerChange: "2.0634742626444",
            OIPerChange: "-0.320793234179061",
            SharesRolled: "54800",
            ROPer: "3.85372714486639",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.157491850712383",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "65221",
            CompanyName: "METROPOLIS HEALTHCARE LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SHRIRAMFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1316",
            PricePerChange: "2.05506010081427",
            OIPerChange: "-0.672162333544705",
            SharesRolled: "225000",
            ROPer: "4.5692701352504",
            RoPer_vs_M1Avg: "0",
            ROCost: "-1.08282674772036",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1745",
            CompanyName: "SHRIRAM FINANCE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PNB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "57.8",
            PricePerChange: "2.03000882612533",
            OIPerChange: "-1.79138321995465",
            SharesRolled: "15248000",
            ROPer: "6.83350064534634",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.605536332179933",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "7855",
            CompanyName: "PUNJAB NATIONAL BANK",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PVR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1670",
            PricePerChange: "2.01899874767097",
            OIPerChange: "0.477685273645421",
            SharesRolled: "104192",
            ROPer: "3.36046206353374",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.16766467065868",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "14622",
            CompanyName: "PVR LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NAVINFLUOR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3960.05",
            PricePerChange: "2.01056156620299",
            OIPerChange: "5.17241379310345",
            SharesRolled: "7050",
            ROPer: "1.68338108882521",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.0984836050049781",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "24585",
            CompanyName: "NAVIN FLUORINE INT. LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BANKBARODA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "187.8",
            PricePerChange: "1.95439739413682",
            OIPerChange: "0.248579545454545",
            SharesRolled: "2825550",
            ROPer: "3.30867242087957",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.106496272630452",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5456",
            CompanyName: "BANK OF BARODA",
        },
        {
            InstName: "FUTSTK",
            Symbol: "JSWSTEEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "746.2",
            PricePerChange: "1.93989071038252",
            OIPerChange: "-0.223623853211009",
            SharesRolled: "373950",
            ROPer: "1.56691933476638",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.509246850710259",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4764",
            CompanyName: "JSW STEEL LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IEX",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "142.15",
            PricePerChange: "1.89964157706094",
            OIPerChange: "-0.208257877580587",
            SharesRolled: "3438750",
            ROPer: "7.68135366057966",
            RoPer_vs_M1Avg: "0",
            ROCost: "0",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "70961",
            CompanyName: "INDIAN ENERGY EXC LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LTIM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4290.3",
            PricePerChange: "1.89526184538654",
            OIPerChange: "0.258505670446965",
            SharesRolled: "111450",
            ROPer: "5.82014726617578",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.209775540172016",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18105",
            CompanyName: "LTIMINDTREE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PFC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "160.6",
            PricePerChange: "1.87123374563907",
            OIPerChange: "2.26357183963169",
            SharesRolled: "1897200",
            ROPer: "2.78993435448578",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.093399750934001",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12068",
            CompanyName: "POWER FIN CORP LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GODREJPROP",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1225",
            PricePerChange: "1.85839604207375",
            OIPerChange: "-0.794387702465697",
            SharesRolled: "134300",
            ROPer: "3.18163511880789",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.791836734693881",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "15613",
            CompanyName: "GODREJ PROPERTIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CANBK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "328.15",
            PricePerChange: "1.81507911883337",
            OIPerChange: "-0.0192443389569568",
            SharesRolled: "1595700",
            ROPer: "3.65333498176423",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.213317080603396",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5471",
            CompanyName: "CANARA BANK",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IBULHSGFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "143.1",
            PricePerChange: "1.81430096051226",
            OIPerChange: "-0.00958129730765546",
            SharesRolled: "5096000",
            ROPer: "10.8795900939368",
            RoPer_vs_M1Avg: "0",
            ROCost: "-1.11809923130677",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "36229",
            CompanyName: "INDIABULLS HSG FIN LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MPHASIS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2017.5",
            PricePerChange: "1.79368803451146",
            OIPerChange: "2.47233748271093",
            SharesRolled: "52525",
            ROPer: "3.12193527296502",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.57001239157373",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3361",
            CompanyName: "MPHASIS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ESCORTS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2207.95",
            PricePerChange: "1.77933482379514",
            OIPerChange: "5.31587057010786",
            SharesRolled: "17875",
            ROPer: "2.3222579492676",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.11096265766887",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "161",
            CompanyName: "ESCORTS KUBOTA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "M&MFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "237.9",
            PricePerChange: "1.73187940987813",
            OIPerChange: "1.52842177571698",
            SharesRolled: "436000",
            ROPer: "1.81033050988208",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.0840689365279481",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "16795",
            CompanyName: "M&M FIN. SERVICES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LUPIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "753.6",
            PricePerChange: "1.69354294582013",
            OIPerChange: "0.582634645445502",
            SharesRolled: "179350",
            ROPer: "2.89477294553437",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.590498938428866",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3026",
            CompanyName: "LUPIN LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ACC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2467",
            PricePerChange: "1.66488090332152",
            OIPerChange: "0.471108547255072",
            SharesRolled: "32500",
            ROPer: "1.22873345935728",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.526955816781516",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "6",
            CompanyName: "ACC LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "RBLBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "187.85",
            PricePerChange: "1.65043290043289",
            OIPerChange: "1.78707805101573",
            SharesRolled: "1250000",
            ROPer: "3.61585189470639",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.558956614319942",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5982",
            CompanyName: "RBL BANK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GLENMARK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "430.95",
            PricePerChange: "1.63915094339622",
            OIPerChange: "-3.50777934936351",
            SharesRolled: "181250",
            ROPer: "3.53506787330317",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.661329620605644",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20600",
            CompanyName: "GLENMARK PHARMACEUTICALS",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ONGC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "150.2",
            PricePerChange: "1.62381596752366",
            OIPerChange: "13.8730303722311",
            SharesRolled: "1235850",
            ROPer: "3.11832135224403",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.266311584553913",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "6068",
            CompanyName: "OIL AND NATURAL GAS CORP.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CHOLAFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "680.5",
            PricePerChange: "1.61266238614304",
            OIPerChange: "2.38999683444128",
            SharesRolled: "116250",
            ROPer: "1.4172508381591",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.374724467303447",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2163",
            CompanyName: "CHOLAMANDALAM IN & FIN CO",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LTTS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3650.6",
            PricePerChange: "1.60311717227943",
            OIPerChange: "-1.22529644268775",
            SharesRolled: "103800",
            ROPer: "9.40728656878738",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.702624226154607",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "44814",
            CompanyName: "L&T TECHNOLOGY SER. LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ZYDUSLIFE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "439.45",
            PricePerChange: "1.59519130736331",
            OIPerChange: "4.86827033218786",
            SharesRolled: "208800",
            ROPer: "2.06810483152077",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.261690749800895",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20883",
            CompanyName: "ZYDUS LIFESCIENCES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MOTHERSON",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "76.75",
            PricePerChange: "1.58835208471211",
            OIPerChange: "-0.170907709836688",
            SharesRolled: "4245750",
            ROPer: "5.64479942564839",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.716612377850159",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2966",
            CompanyName: "SAMVRDHNA MTHRSN INTL LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "AXISBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "960.2",
            PricePerChange: "1.57084677632623",
            OIPerChange: "-0.631532500482612",
            SharesRolled: "1239600",
            ROPer: "2.78699581815729",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.614455321807954",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5554",
            CompanyName: "AXIS BANK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DRREDDY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4349.3",
            PricePerChange: "1.55390811978285",
            OIPerChange: "-0.691270566727605",
            SharesRolled: "19125",
            ROPer: "0.872490875912409",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.44949762030672",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "815",
            CompanyName: "DR. REDDY S LABORATORIES",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATASTEEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "118",
            PricePerChange: "1.54905335628227",
            OIPerChange: "1.24561034907104",
            SharesRolled: "6974000",
            ROPer: "3.62285714285714",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.593220338983053",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "566",
            CompanyName: "TATA STEEL LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "813.35",
            PricePerChange: "1.4911405041178",
            OIPerChange: "-0.520015698587127",
            SharesRolled: "336600",
            ROPer: "5.69249372151428",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.577857011126813",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "412",
            CompanyName: "PIRAMAL ENTERPRISES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HINDUNILVR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2628.35",
            PricePerChange: "1.47677695841859",
            OIPerChange: "1.68601234205113",
            SharesRolled: "78000",
            ROPer: "0.930465590666714",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.519337226777259",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "255",
            CompanyName: "HINDUSTAN UNILEVER LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "JINDALSTEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "602.25",
            PricePerChange: "1.4572102425876",
            OIPerChange: "0.844573301399218",
            SharesRolled: "348750",
            ROPer: "1.71386448799066",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.24906600249066",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20287",
            CompanyName: "JINDAL STEEL & POWER LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ADANIPORTS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "821.9",
            PricePerChange: "1.4566102950253",
            OIPerChange: "-0.0531808147702187",
            SharesRolled: "429375",
            ROPer: "0.684986140746206",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.620513444457966",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "21281",
            CompanyName: "ADANI PORT & SEZ LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DLF",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "376.4",
            PricePerChange: "1.455525606469",
            OIPerChange: "-1.10939209841138",
            SharesRolled: "570900",
            ROPer: "1.30305426882085",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.597768331562168",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "6890",
            CompanyName: "DLF LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "VEDL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "315.85",
            PricePerChange: "1.42903018625563",
            OIPerChange: "-1.07612839749108",
            SharesRolled: "1038000",
            ROPer: "3.12537636998675",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.601551369320873",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "502",
            CompanyName: "VEDANTA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ITC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "340.85",
            PricePerChange: "1.41326986016067",
            OIPerChange: "1.9174188400738",
            SharesRolled: "5187200",
            ROPer: "7.348641113403",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.792137303799339",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "301",
            CompanyName: "ITC LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BANDHANBNK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "247.3",
            PricePerChange: "1.3940139401394",
            OIPerChange: "3.1398530894426",
            SharesRolled: "811800",
            ROPer: "1.55009451795841",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.444803881924785",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "68090",
            CompanyName: "BANDHAN BANK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ALKEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3047",
            PricePerChange: "1.38754866402688",
            OIPerChange: "3.17460317460317",
            SharesRolled: "15200",
            ROPer: "4.64547677261614",
            RoPer_vs_M1Avg: "0",
            ROCost: "-1.23235969806368",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "19299",
            CompanyName: "ALKEM LABORATORIES LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NMDC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "124.25",
            PricePerChange: "1.38718890248878",
            OIPerChange: "0.606722485135299",
            SharesRolled: "823500",
            ROPer: "2.15954684918574",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.281690140845066",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12059",
            CompanyName: "NMDC LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CIPLA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1096.45",
            PricePerChange: "1.35422444074691",
            OIPerChange: "1.89566034779884",
            SharesRolled: "52650",
            ROPer: "0.618840247536099",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.506179032331612",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "114",
            CompanyName: "CIPLA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATACOMM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1348.95",
            PricePerChange: "1.34861006761834",
            OIPerChange: "0.554575245777666",
            SharesRolled: "50000",
            ROPer: "2.44558571777941",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.596760443307754",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2295",
            CompanyName: "TATA COMMUNICATIONS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2126.45",
            PricePerChange: "1.34156221703282",
            OIPerChange: "2.62217359591539",
            SharesRolled: "130800",
            ROPer: "1.52580927384077",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.543158785769719",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "348",
            CompanyName: "LARSEN & TOUBRO LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "POWERGRID",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "212",
            PricePerChange: "1.33843212237094",
            OIPerChange: "0.176743500994182",
            SharesRolled: "1965600",
            ROPer: "5.07989672737422",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.448113207547164",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5455",
            CompanyName: "POWER GRID CORP. LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "UPL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "730.6",
            PricePerChange: "1.32445738853062",
            OIPerChange: "-0.863034455497727",
            SharesRolled: "254800",
            ROPer: "1.28575177118866",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.875992335067065",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2461",
            CompanyName: "UPL LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IDFC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "84.6",
            PricePerChange: "1.31736526946107",
            OIPerChange: "0.298049132947977",
            SharesRolled: "2080000",
            ROPer: "1.83859276938036",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.768321513002371",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "22265",
            CompanyName: "IDFC LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ASHOKLEY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "150.55",
            PricePerChange: "1.31224764468373",
            OIPerChange: "1.363054446871",
            SharesRolled: "1445000",
            ROPer: "2.10197105244018",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.431750249086667",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "31",
            CompanyName: "ASHOK LEYLAND LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SAIL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "87.5",
            PricePerChange: "1.27314814814814",
            OIPerChange: "0.642441276852038",
            SharesRolled: "8112000",
            ROPer: "6.31657634087087",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.171428571428578",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2299",
            CompanyName: "STEEL AUTHORITY OF INDIA",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SBILIFE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1292.5",
            PricePerChange: "1.2494614390349",
            OIPerChange: "2.55417956656347",
            SharesRolled: "60000",
            ROPer: "0.85515766969535",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.742746615087034",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "22045",
            CompanyName: "SBI LIFE INSURANCE CO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CONCOR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "748.5",
            PricePerChange: "1.23757354432948",
            OIPerChange: "0.0164962058726493",
            SharesRolled: "84000",
            ROPer: "1.36652025378233",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.0267201068804336",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12607",
            CompanyName: "CONTAINER CORP OF IND LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NESTLEIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "20175.05",
            PricePerChange: "1.22015768731954",
            OIPerChange: "3.13893653516295",
            SharesRolled: "11960",
            ROPer: "4.73700887198986",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.495909551649187",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "175",
            CompanyName: "NESTLE INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BAJFINANCE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "6086.4",
            PricePerChange: "1.19965082928045",
            OIPerChange: "-0.376619744569777",
            SharesRolled: "424875",
            ROPer: "5.98078547297297",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.478115141955842",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3722",
            CompanyName: "BAJAJ FINANCE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HDFC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2642",
            PricePerChange: "1.19503600428987",
            OIPerChange: "2.64150943396226",
            SharesRolled: "234300",
            ROPer: "1.19205702336798",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.522331566994708",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "230",
            CompanyName: "HDFC LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "OBEROIRLTY",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "866.95",
            PricePerChange: "1.16102683780631",
            OIPerChange: "-0.303848750844024",
            SharesRolled: "20300",
            ROPer: "0.326282628262826",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.542130457350474",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "38025",
            CompanyName: "OBEROI REALTY LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IPCALAB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "868",
            PricePerChange: "1.15371168861438",
            OIPerChange: "4.31244914564687",
            SharesRolled: "28600",
            ROPer: "1.68711656441718",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.230414746543779",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3617",
            CompanyName: "IPCA LABORATORIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TORNTPHARM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1570",
            PricePerChange: "1.14675943821672",
            OIPerChange: "0.148279952550415",
            SharesRolled: "4500",
            ROPer: "0.265800354400473",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.684713375796178",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3616",
            CompanyName: "TORRENT PHARMACEUTICALS L",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HDFCBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1616.55",
            PricePerChange: "1.12602045603828",
            OIPerChange: "1.23908646968875",
            SharesRolled: "2968900",
            ROPer: "4.9972689989724",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.497974080603752",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4987",
            CompanyName: "HDFC BANK LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "AUBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "626.4",
            PricePerChange: "1.12196303172168",
            OIPerChange: "-2.23204885238998",
            SharesRolled: "286000",
            ROPer: "2.98788132051818",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.734355044699876",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "34695",
            CompanyName: "AU SMALL FINANCE BANK LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GRANULES",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "324.95",
            PricePerChange: "1.12027384471759",
            OIPerChange: "0.282195997947665",
            SharesRolled: "294000",
            ROPer: "3.62426035502959",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.938605939375292",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12632",
            CompanyName: "GRANULES INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CUMMINSIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1441.9",
            PricePerChange: "1.10791669588389",
            OIPerChange: "0.859710824540836",
            SharesRolled: "45600",
            ROPer: "2.86036883703425",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.880782301130456",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "337",
            CompanyName: "CUMMINS INDIA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "OFSS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3037.6",
            PricePerChange: "1.10336334437252",
            OIPerChange: "2.97152290548906",
            SharesRolled: "31600",
            ROPer: "5.95552205050886",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.493810903344746",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "13105",
            CompanyName: "ORACLE FIN SERV SOFT LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SBIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "610.55",
            PricePerChange: "1.09280569583573",
            OIPerChange: "0.204544198131461",
            SharesRolled: "3432000",
            ROPer: "5.93668915412558",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.196544099582351",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1375",
            CompanyName: "STATE BANK OF INDIA",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MUTHOOTFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1076",
            PricePerChange: "1.07557183786577",
            OIPerChange: "0.266165648974479",
            SharesRolled: "200200",
            ROPer: "2.76343759489827",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.743494423791822",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "24769",
            CompanyName: "MUTHOOT FINANCE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "KOTAKBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1813.95",
            PricePerChange: "1.07541860529908",
            OIPerChange: "-0.379898776156711",
            SharesRolled: "741600",
            ROPer: "2.25114742951504",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.518206124755361",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2330",
            CompanyName: "KOTAK MAHINDRA BANK LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LALPATHLAB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2216.35",
            PricePerChange: "1.06014317632575",
            OIPerChange: "2.14896724389735",
            SharesRolled: "96000",
            ROPer: "7.27272727272727",
            RoPer_vs_M1Avg: "0",
            ROCost: "-1.99426985810002",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "41261",
            CompanyName: "DR. LAL PATH LABS LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "APOLLOHOSP",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4449.5",
            PricePerChange: "1.0503605291546",
            OIPerChange: "-0.277185501066098",
            SharesRolled: "25125",
            ROPer: "1.41231028667791",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.368580739408914",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "636",
            CompanyName: "APOLLO HOSPITALS ENTER. L",
        },
        {
            InstName: "FUTSTK",
            Symbol: "AMBUJACEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "528.4",
            PricePerChange: "1.01319059453259",
            OIPerChange: "-0.0923259545844233",
            SharesRolled: "2838600",
            ROPer: "3.35346404116872",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.643451930355787",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "218",
            CompanyName: "AMBUJA CEMENTS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDIACEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "220.8",
            PricePerChange: "1.00640439158281",
            OIPerChange: "-0.374458021284982",
            SharesRolled: "237800",
            ROPer: "1.59626240996691",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.317028985507241",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "270",
            CompanyName: "THE INDIA CEMENTS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "RECLTD",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "125.5",
            PricePerChange: "1.00603621730382",
            OIPerChange: "0.955550783766373",
            SharesRolled: "2560000",
            ROPer: "3.29116527820632",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.199203187250996",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18075",
            CompanyName: "REC LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "100.55",
            PricePerChange: "1.00452034153692",
            OIPerChange: "0.851331276425551",
            SharesRolled: "6235800",
            ROPer: "5.83622299279808",
            RoPer_vs_M1Avg: "0",
            ROCost: "0",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2298",
            CompanyName: "BHARAT ELECTRONICS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SYNGENE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "604.4",
            PricePerChange: "1.00267379679144",
            OIPerChange: "-0.90978013646702",
            SharesRolled: "27000",
            ROPer: "2.023988005997",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.248180013236267",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "25767",
            CompanyName: "SYNGENE INTERNATIONAL LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ASIANPAINT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3017.45",
            PricePerChange: "1.00082006995698",
            OIPerChange: "1.59777342542006",
            SharesRolled: "153600",
            ROPer: "2.53164556962025",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.568360701917185",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "34",
            CompanyName: "ASIAN PAINTS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "FEDERALBNK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "136.5",
            PricePerChange: "0.998890122086566",
            OIPerChange: "-1.36786188579017",
            SharesRolled: "1715000",
            ROPer: "2.25702441271304",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.366300366300366",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3709",
            CompanyName: "FEDERAL BANK LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ABCAPITAL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "147.2",
            PricePerChange: "0.994854202401364",
            OIPerChange: "-0.570484912175349",
            SharesRolled: "772200",
            ROPer: "2.11350872007094",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.611413043478265",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "40903",
            CompanyName: "ADITYA BIRLA CAPITAL LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDHOTEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "315.1",
            PricePerChange: "0.977407466752127",
            OIPerChange: "-0.224823629738739",
            SharesRolled: "858000",
            ROPer: "3.2258064516129",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.602983179942868",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "282",
            CompanyName: "THE INDIAN HOTELS CO. LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BATAINDIA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1645.15",
            PricePerChange: "0.972810409378269",
            OIPerChange: "-0.296397628818969",
            SharesRolled: "54725",
            ROPer: "2.22470653996646",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.64127891073762",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "60",
            CompanyName: "BATA INDIA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BPCL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "349.55",
            PricePerChange: "0.953068592057765",
            OIPerChange: "0.997697620874904",
            SharesRolled: "739800",
            ROPer: "4.94763452509931",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.243169789729659",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2290",
            CompanyName: "BHARAT PETROLEUM CORP  LT",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ASTRAL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2090.2",
            PricePerChange: "0.93439891831856",
            OIPerChange: "5.24074680641992",
            SharesRolled: "27225",
            ROPer: "1.51724137931034",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.533441775906616",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "27655",
            CompanyName: "ASTRAL LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IDFCFIRSTB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "60.25",
            PricePerChange: "0.921273031825791",
            OIPerChange: "0.461050811641533",
            SharesRolled: "8760000",
            ROPer: "5.28841800235443",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.663900414937757",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "54759",
            CompanyName: "IDFC FIRST BANK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GAIL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "98.65",
            PricePerChange: "0.920716112531975",
            OIPerChange: "-0.656243968345879",
            SharesRolled: "1839150",
            ROPer: "3.7584143605086",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.152052711606682",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12350",
            CompanyName: "GAIL (INDIA) LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PIDILITIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2555",
            PricePerChange: "0.880483278714423",
            OIPerChange: "-0.20386370255315",
            SharesRolled: "29750",
            ROPer: "1.14434080200019",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.677103718199616",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3219",
            CompanyName: "PIDILITE INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ULTRACEMCO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "7066.15",
            PricePerChange: "0.863588674855295",
            OIPerChange: "0.1190149226403",
            SharesRolled: "25600",
            ROPer: "1.15690527838033",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.522207991622037",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "24951",
            CompanyName: "ULTRATECH CEMENT LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "JUBLFOOD",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "504.75",
            PricePerChange: "0.859226695973626",
            OIPerChange: "0.330141961043249",
            SharesRolled: "720000",
            ROPer: "4.52403393025448",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.683506686478452",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "14548",
            CompanyName: "JUBILANT FOODWORKS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IGL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "422",
            PricePerChange: "0.84836898076234",
            OIPerChange: "1.24398739426107",
            SharesRolled: "155375",
            ROPer: "1.81759691169374",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.319905213270148",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20703",
            CompanyName: "INDRAPRASTHA GAS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "RAIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "175.65",
            PricePerChange: "0.832376578645245",
            OIPerChange: "0.429184549356223",
            SharesRolled: "294000",
            ROPer: "2.68714011516315",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.825505266154278",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "955",
            CompanyName: "RAIN INDUSTRIES LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SUNPHARMA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1021.25",
            PricePerChange: "0.829342943180133",
            OIPerChange: "1.96648663619997",
            SharesRolled: "168700",
            ROPer: "1.07926556202418",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.0244798041615667",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4325",
            CompanyName: "SUN PHARMACEUTICAL IND L",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DIVISLAB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3467.5",
            PricePerChange: "0.82433159356236",
            OIPerChange: "-0.263466042154567",
            SharesRolled: "50100",
            ROPer: "1.92296620415683",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.428262436914201",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "21188",
            CompanyName: "DIVI S LABORATORIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "VOLTAS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "824.8",
            PricePerChange: "0.818970785967477",
            OIPerChange: "0.82460854257389",
            SharesRolled: "262800",
            ROPer: "3.86925795053004",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.460717749757525",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "597",
            CompanyName: "VOLTAS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BALRAMCHIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "388.7",
            PricePerChange: "0.817014654389827",
            OIPerChange: "-0.837188808107513",
            SharesRolled: "1014400",
            ROPer: "12.3466407010711",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.398765114484181",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2208",
            CompanyName: "BALRAMPUR CHINI MILLS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MCX",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1458.9",
            PricePerChange: "0.798010156492913",
            OIPerChange: "0.671140939597315",
            SharesRolled: "33200",
            ROPer: "2.34927823379564",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.418123243539647",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "25746",
            CompanyName: "MULTI COMMODITY EXCHANGE",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CROMPTON",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "342.35",
            PricePerChange: "0.794935963491843",
            OIPerChange: "2.37871674491393",
            SharesRolled: "147000",
            ROPer: "2.908875037103",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.131444428216734",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "65733",
            CompanyName: "CROMPT GREA CON ELEC LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ICICIBANK",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "881.75",
            PricePerChange: "0.754156430326232",
            OIPerChange: "2.53190159232155",
            SharesRolled: "2919700",
            ROPer: "3.6051064418265",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.578395236745112",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5418",
            CompanyName: "ICICI BANK LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GMRINFRA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "40.6",
            PricePerChange: "0.744416873449142",
            OIPerChange: "0.196592398427261",
            SharesRolled: "4612500",
            ROPer: "3.24315772820756",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.738916256157628",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "23039",
            CompanyName: "GMR AIRPORTS INFRA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDIAMART",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4291.1",
            PricePerChange: "0.718225560380246",
            OIPerChange: "0.478214665249734",
            SharesRolled: "14100",
            ROPer: "4.73551637279597",
            RoPer_vs_M1Avg: "0",
            ROCost: "-1.15238516930392",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "68842",
            CompanyName: "INDIAMART INTERMESH LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NTPC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "171.1",
            PricePerChange: "0.676669608708447",
            OIPerChange: "0.725313439021863",
            SharesRolled: "1681500",
            ROPer: "2.9452875399361",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.0584453535943859",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12001",
            CompanyName: "NTPC LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ADANIENT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3863.55",
            PricePerChange: "0.667022759546121",
            OIPerChange: "-1.06146277735818",
            SharesRolled: "1090500",
            ROPer: "8.25651606064621",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.209651745156666",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4244",
            CompanyName: "ADANI ENTERPRISES LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IRCTC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "641.4",
            PricePerChange: "0.643339086772324",
            OIPerChange: "-0.585122938064115",
            SharesRolled: "1096375",
            ROPer: "7.27473293079424",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.0935453695042131",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "23401",
            CompanyName: "INDIAN RAIL TOUR CORP LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDIGO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2037.4",
            PricePerChange: "0.624768489937034",
            OIPerChange: "-0.946215139442231",
            SharesRolled: "48900",
            ROPer: "1.61258409180847",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.471188770000977",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "33159",
            CompanyName: "INTERGLOBE AVIATION LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATACONSUM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "768.1",
            PricePerChange: "0.602488539620173",
            OIPerChange: "1.37693631669535",
            SharesRolled: "138600",
            ROPer: "1.51470443592013",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.618409061320141",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "557",
            CompanyName: "TATA CONSUMER PRODUCT LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MGL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "869.45",
            PricePerChange: "0.595857919703817",
            OIPerChange: "-0.0694927032661571",
            SharesRolled: "107200",
            ROPer: "4.45182724252492",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.655586865259652",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "13369",
            CompanyName: "MAHANAGAR GAS LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GRASIM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1696",
            PricePerChange: "0.593119810201661",
            OIPerChange: "1.75438596491228",
            SharesRolled: "33250",
            ROPer: "0.414446417998816",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.648584905660377",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "227",
            CompanyName: "GRASIM INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DELTACORP",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "212.25",
            PricePerChange: "0.592417061611374",
            OIPerChange: "0.640683395621997",
            SharesRolled: "638400",
            ROPer: "3.87557368689444",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.683156654888098",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "17211",
            CompanyName: "DELTA CORP LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CHAMBLFERT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "316.85",
            PricePerChange: "0.587301587301594",
            OIPerChange: "0.106883283454468",
            SharesRolled: "690000",
            ROPer: "8.94419599455571",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.268265740886862",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3029",
            CompanyName: "CHAMBAL FERTILIZERS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BALKRISIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2222.85",
            PricePerChange: "0.574621632015918",
            OIPerChange: "0.590704181563812",
            SharesRolled: "29100",
            ROPer: "1.4768574908648",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.510605753874526",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "55",
            CompanyName: "BALKRISHNA IND. LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BOSCHLTD",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "17155",
            PricePerChange: "0.555974009607175",
            OIPerChange: "0.264250660626652",
            SharesRolled: "1700",
            ROPer: "1.2639405204461",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.670067035849611",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "378",
            CompanyName: "BOSCH LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TORNTPOWER",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "484.5",
            PricePerChange: "0.54996368164366",
            OIPerChange: "0.0903750564844103",
            SharesRolled: "82500",
            ROPer: "2.42290748898678",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.908152734778117",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18488",
            CompanyName: "TORRENT POWER LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BHARATFORG",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "878.05",
            PricePerChange: "0.532402106709409",
            OIPerChange: "0.723299476762081",
            SharesRolled: "92000",
            ROPer: "1.38616844960072",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.649165765047554",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "69",
            CompanyName: "BHARAT FORGE LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "COALINDIA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "215.15",
            PricePerChange: "0.51389862181733",
            OIPerChange: "3.99201596806387",
            SharesRolled: "2965200",
            ROPer: "9.43976467442172",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.162677201952124",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12019",
            CompanyName: "COAL INDIA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MINDTREE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3449.85",
            PricePerChange: "0.511318940652033",
            OIPerChange: "0",
            SharesRolled: "0",
            ROPer: "0",
            RoPer_vs_M1Avg: "0",
            ROCost: null,
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20581",
            CompanyName: "MINDTREE LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SHREECEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "23788.75",
            PricePerChange: "0.505086779443324",
            OIPerChange: "0.994694960212201",
            SharesRolled: "3975",
            ROPer: "1.46950092421442",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.722820661026749",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "508",
            CompanyName: "SHREE CEMENT LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PETRONET",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "219.55",
            PricePerChange: "0.503547722590992",
            OIPerChange: "-0.118371212121212",
            SharesRolled: "243000",
            ROPer: "1.88372093023256",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.29606012297881",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20099",
            CompanyName: "PETRONET LNG LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HEROMOTOCO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2768.4",
            PricePerChange: "0.493683751996512",
            OIPerChange: "1.39990089197225",
            SharesRolled: "74400",
            ROPer: "2.94082770069963",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.19505851755527",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "237",
            CompanyName: "HERO MOTOCORP LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MARUTI",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "8465.25",
            PricePerChange: "0.443170896664654",
            OIPerChange: "1.42302716688228",
            SharesRolled: "73100",
            ROPer: "2.59486706187214",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.610732110687821",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "5496",
            CompanyName: "MARUTI SUZUKI INDIA LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATAPOWER",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "206.95",
            PricePerChange: "0.43678718757582",
            OIPerChange: "0.582236947920353",
            SharesRolled: "4765500",
            ROPer: "4.32068543451652",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.628171055810588",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "554",
            CompanyName: "TATA POWER CO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GUJGASLTD",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "485.3",
            PricePerChange: "0.434602649006627",
            OIPerChange: "0.0867553499132447",
            SharesRolled: "230000",
            ROPer: "5.0480109739369",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.597568514321034",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "43934",
            CompanyName: "GUJARAT GAS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TATACHEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "956.3",
            PricePerChange: "0.425308479915984",
            OIPerChange: "0.178788528927984",
            SharesRolled: "267500",
            ROPer: "3.67874578835178",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.439192721949184",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "552",
            CompanyName: "TATA CHEMICALS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HAL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2521.7",
            PricePerChange: "0.414128140803553",
            OIPerChange: "0.555294117647059",
            SharesRolled: "153600",
            ROPer: "4.5730618077885",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.146726414720221",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12030",
            CompanyName: "HINDUSTAN AERONAUTICS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HONAUT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "40096.85",
            PricePerChange: "0.410563720641369",
            OIPerChange: "-0.611246943765281",
            SharesRolled: "360",
            ROPer: "0.97442143727162",
            RoPer_vs_M1Avg: "0",
            ROCost: "1.06255229525512",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1131",
            CompanyName: "HONEYWELL AUTOMATION IND",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ABB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2863.55",
            PricePerChange: "0.404978962131844",
            OIPerChange: "-0.317414514500072",
            SharesRolled: "12500",
            ROPer: "0.718494036499497",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.46969670513872",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "242",
            CompanyName: "ABB INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MCDOWELL-N",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "862",
            PricePerChange: "0.378457059679767",
            OIPerChange: "0.357218796512864",
            SharesRolled: "186875",
            ROPer: "1.25115072390995",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.626450116009278",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "8036",
            CompanyName: "UNITED SPIRITS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SIEMENS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2909",
            PricePerChange: "0.377840271906966",
            OIPerChange: "0.875085792724777",
            SharesRolled: "15675",
            ROPer: "0.960242587601078",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.206256445513922",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "514",
            CompanyName: "SIEMENS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "CUB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "176.15",
            PricePerChange: "0.370370370370374",
            OIPerChange: "3.49154391707583",
            SharesRolled: "590000",
            ROPer: "5.8560794044665",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.227079193868865",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "7015",
            CompanyName: "CITY UNION BANK LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BHEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "82.3",
            PricePerChange: "0.365853658536582",
            OIPerChange: "1.28765792031098",
            SharesRolled: "5124000",
            ROPer: "5.52911851348289",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.546780072904013",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2306",
            CompanyName: "BHEL",
        },
        {
            InstName: "FUTSTK",
            Symbol: "AARTIIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "601",
            PricePerChange: "0.342265631521822",
            OIPerChange: "0.13869625520111",
            SharesRolled: "201450",
            ROPer: "6.1606446581752",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.366056572379375",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2378",
            CompanyName: "AARTI INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "EXIDEIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "180",
            PricePerChange: "0.334448160535114",
            OIPerChange: "0",
            SharesRolled: "5407200",
            ROPer: "18.8220551378446",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.249999999999994",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "111",
            CompanyName: "EXIDE INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DALBHARAT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1889.5",
            PricePerChange: "0.323882340448121",
            OIPerChange: "1.94862710363153",
            SharesRolled: "10500",
            ROPer: "0.904003443822643",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.330775337390844",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "70921",
            CompanyName: "DALMIA BHARAT LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PIIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3316.8",
            PricePerChange: "0.305440469350118",
            OIPerChange: "1.15848753016895",
            SharesRolled: "6000",
            ROPer: "0.380288385358897",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.676857211770376",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2650",
            CompanyName: "PI INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DEEPAKNTR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1947.5",
            PricePerChange: "0.249658970993226",
            OIPerChange: "-0.843881856540084",
            SharesRolled: "98000",
            ROPer: "6.7621183370709",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.179717586649551",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "136",
            CompanyName: "DEEPAK NITRITE LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BAJAJFINSV",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1441.75",
            PricePerChange: "0.243351294976534",
            OIPerChange: "3.1804899977523",
            SharesRolled: "513000",
            ROPer: "5.29193315452858",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.58609328940524",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "28075",
            CompanyName: "BAJAJ FINSERV LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MARICO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "516.2",
            PricePerChange: "0.20382412889451",
            OIPerChange: "0.244358200373724",
            SharesRolled: "218400",
            ROPer: "2.54332029066518",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.397132894227057",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12585",
            CompanyName: "MARICO LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "POLYCAB",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2632.65",
            PricePerChange: "0.20172417074239",
            OIPerChange: "-1.78087495160666",
            SharesRolled: "19200",
            ROPer: "2.46059207996924",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.100659031774071",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "26603",
            CompanyName: "POLYCAB INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SBICARD",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "776.5",
            PricePerChange: "0.20001290405832",
            OIPerChange: "0.466074138304791",
            SharesRolled: "224000",
            ROPer: "2.93224421405383",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.579523502897617",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "20149",
            CompanyName: "SBI CARDS & PAY SER LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SUNTV",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "481.5",
            PricePerChange: "0.197690146706896",
            OIPerChange: "0.238967659710053",
            SharesRolled: "214500",
            ROPer: "2.22222222222222",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.103842159916926",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "15228",
            CompanyName: "SUN TV NETWORK LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IOC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "80.65",
            PricePerChange: "0.186335403726715",
            OIPerChange: "3.27732093910142",
            SharesRolled: "4241250",
            ROPer: "4.77969453906164",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.433973961562299",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12002",
            CompanyName: "INDIAN OIL CORP LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "NAUKRI",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3692.05",
            PricePerChange: "0.180441743094375",
            OIPerChange: "2.88805354359586",
            SharesRolled: "71875",
            ROPer: "4.87412053912012",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.35075364634823",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18844",
            CompanyName: "INFO EDGE (I) LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "COROMANDEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "905.65",
            PricePerChange: "0.171441212255276",
            OIPerChange: "-0.0700934579439252",
            SharesRolled: "70700",
            ROPer: "2.30698949291914",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.149064208027386",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "123",
            CompanyName: "COROMANDEL INTERNTL. LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "COLPAL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1526.55",
            PricePerChange: "0.16075060691556",
            OIPerChange: "0.177076625885383",
            SharesRolled: "31500",
            ROPer: "1.42562965309678",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.553535750548626",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "118",
            CompanyName: "COLGATE PALMOLIVE LTD.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "JKCEMENT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2885.5",
            PricePerChange: "0.159672324620775",
            OIPerChange: "0.106553010122536",
            SharesRolled: "11250",
            ROPer: "2.33887733887734",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.329232368740253",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "17136",
            CompanyName: "JK CEMENT LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GNFC",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "591.75",
            PricePerChange: "0.0930311231393698",
            OIPerChange: "5.81487971961128",
            SharesRolled: "309400",
            ROPer: "3.4593023255814",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.675961132234897",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "213",
            CompanyName: "GUJ NAR VAL FER & CHEM L",
        },
        {
            InstName: "FUTSTK",
            Symbol: "RAMCOCEM",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "711.25",
            PricePerChange: "0.0773884902209026",
            OIPerChange: "0.721500721500722",
            SharesRolled: "93500",
            ROPer: "2.55932992089344",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.168717047451676",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "357",
            CompanyName: "THE RAMCO CEMENTS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LICHSGFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "405.85",
            PricePerChange: "0.0616370808678501",
            OIPerChange: "3.69854534199938",
            SharesRolled: "480000",
            ROPer: "3.45771502665322",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.357274855242082",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4248",
            CompanyName: "LIC HOUSING FINANCE LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "AUROPHARMA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "444.4",
            PricePerChange: "0.0450247636199884",
            OIPerChange: "0.628043186789923",
            SharesRolled: "777000",
            ROPer: "5.16725410653721",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.292529252925295",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "4666",
            CompanyName: "AUROBINDO PHARMA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BERGEPAINT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "569.5",
            PricePerChange: "0.026345832967415",
            OIPerChange: "4.47816432272391",
            SharesRolled: "190300",
            ROPer: "2.97301941914418",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.535557506584715",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "64",
            CompanyName: "BERGER PAINTS (I) LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "UBL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1661.1",
            PricePerChange: "0.00903097624852425",
            OIPerChange: "0.685192234488009",
            SharesRolled: "10400",
            ROPer: "0.973418195432422",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.0571910180001095",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "23220",
            CompanyName: "UNITED BREWERIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MRF",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "92870",
            PricePerChange: "5.38387282462308E-05",
            OIPerChange: "1.45767146327789",
            SharesRolled: "2000",
            ROPer: "3.553028957186",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.237051792828679",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "391",
            CompanyName: "MRF LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ZEEL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "238.4",
            PricePerChange: "-0.0209687565527293",
            OIPerChange: "0.293822293301596",
            SharesRolled: "1344000",
            ROPer: "1.63420150288174",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.817953020134223",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3126",
            CompanyName: "ZEE ENTERTAINMENT ENT LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DIXON",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3818.15",
            PricePerChange: "-0.0706649044060829",
            OIPerChange: "1.90937589056711",
            SharesRolled: "24625",
            ROPer: "5.22130930294196",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.636433875044202",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "35727",
            CompanyName: "DIXON TECHNO (INDIA) LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "LTI",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "5115",
            PricePerChange: "-0.0713078643782958",
            OIPerChange: "0",
            SharesRolled: "3450",
            ROPer: "4.82180293501048",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.684261974584555",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "18105",
            CompanyName: "L&T INFOTECH LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BRITANNIA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "4365.2",
            PricePerChange: "-0.116696794270425",
            OIPerChange: "3.62112022832679",
            SharesRolled: "34000",
            ROPer: "2.84328483023917",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.556675524603688",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "93",
            CompanyName: "BRITANNIA INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "EICHERMOT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3264.45",
            PricePerChange: "-0.131548757170178",
            OIPerChange: "1.56456297861104",
            SharesRolled: "39025",
            ROPer: "1.42875448487955",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.490128505567554",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "151",
            CompanyName: "EICHER MOTORS LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TVSMOTOR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1026.8",
            PricePerChange: "-0.136160280101156",
            OIPerChange: "-0.12246820536976",
            SharesRolled: "169400",
            ROPer: "2.23164883806713",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.175301908843003",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "8029",
            CompanyName: "TVS MOTOR COMPANY  LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "PAGEIND",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "41769.95",
            PricePerChange: "-0.238596507988449",
            OIPerChange: "2.69797287443488",
            SharesRolled: "2070",
            ROPer: "1.92200557103064",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.550754789028962",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "12521",
            CompanyName: "PAGE INDUSTRIES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BAJAJ-AUTO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "3646.4",
            PricePerChange: "-0.244846594717327",
            OIPerChange: "4.15966386554622",
            SharesRolled: "23750",
            ROPer: "1.88007124480507",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.537516454585342",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "28074",
            CompanyName: "BAJAJ AUTO LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SRF",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2244",
            PricePerChange: "-0.306544049047052",
            OIPerChange: "1.87303165920769",
            SharesRolled: "95625",
            ROPer: "2.03235833266916",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.490196078431373",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "513",
            CompanyName: "SRF LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HINDPETRO",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "250",
            PricePerChange: "-0.318979266347692",
            OIPerChange: "1.5382557517389",
            SharesRolled: "442800",
            ROPer: "2.11476466795616",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.560000000000002",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "2305",
            CompanyName: "HINDUSTAN PETROLEUM CORP",
        },
        {
            InstName: "FUTSTK",
            Symbol: "BIOCON",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "256.5",
            PricePerChange: "-0.330289489022741",
            OIPerChange: "1.6354920575242",
            SharesRolled: "1225900",
            ROPer: "4.69769081614666",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.662768031189079",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "14801",
            CompanyName: "BIOCON LIMITED.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "SRTRANSFIN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1291.55",
            PricePerChange: "-0.381797146162749",
            OIPerChange: "0",
            SharesRolled: "226200",
            ROPer: "27.4381368267831",
            RoPer_vs_M1Avg: "0",
            ROCost: "-0.0851689830049095",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1745",
            CompanyName: "SHRIRAM TRANSPORT FIN CO.",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HDFCLIFE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "611.5",
            PricePerChange: "-0.415275629020431",
            OIPerChange: "1.48551018751522",
            SharesRolled: "258500",
            ROPer: "1.8450184501845",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.572363041700736",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "21997",
            CompanyName: "HDFC LIFE INS CO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ABFRL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "277.65",
            PricePerChange: "-0.43033889187737",
            OIPerChange: "3.33073626801714",
            SharesRolled: "481000",
            ROPer: "3.36976320582878",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.684314784801021",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "40912",
            CompanyName: "ADITYA BIRLA FASHION & RT",
        },
        {
            InstName: "FUTSTK",
            Symbol: "WHIRLPOOL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1500.65",
            PricePerChange: "-0.507193529138756",
            OIPerChange: "0.551931761164074",
            SharesRolled: "14700",
            ROPer: "2.05278592375367",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.123279912038111",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "328",
            CompanyName: "WHIRLPOOL OF INDIA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ATUL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "7760.85",
            PricePerChange: "-0.527428864393741",
            OIPerChange: "1.00946372239748",
            SharesRolled: "2550",
            ROPer: "2.07951070336391",
            RoPer_vs_M1Avg: "0",
            ROCost: "1.29045143251061",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "43",
            CompanyName: "ATUL LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "DABUR",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "550.7",
            PricePerChange: "-0.649467797221705",
            OIPerChange: "2.63480392156863",
            SharesRolled: "151250",
            ROPer: "1.18965686756464",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.753586344652257",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3392",
            CompanyName: "DABUR INDIA LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ICICIPRULI",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "469.8",
            PricePerChange: "-0.886075949367086",
            OIPerChange: "1.38572340231562",
            SharesRolled: "327000",
            ROPer: "1.92256812770086",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.063856960408687",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "22005",
            CompanyName: "ICICI PRU LIFE INS CO LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "MFSL",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "738.75",
            PricePerChange: "-0.905432595573441",
            OIPerChange: "2.37729154346541",
            SharesRolled: "44850",
            ROPer: "0.790830945558739",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.0812182741116782",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "372",
            CompanyName: "MAX FINANCIAL SERV LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ICICIGI",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1262.1",
            PricePerChange: "-0.918511540273202",
            OIPerChange: "2.16355441081777",
            SharesRolled: "39100",
            ROPer: "1.14641744548287",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.685365660407265",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "22664",
            CompanyName: "ICICI LOMBARD GIC LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "ABBOTINDIA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "22164.05",
            PricePerChange: "-0.961383784943168",
            OIPerChange: "-0.688468158347676",
            SharesRolled: "1920",
            ROPer: "3.99334442595674",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.176637392534313",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "90",
            CompanyName: "ABBOTT INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "HAVELLS",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1182.35",
            PricePerChange: "-1.04615642130811",
            OIPerChange: "0.694228577349497",
            SharesRolled: "108000",
            ROPer: "2.17435071471713",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.397513426650319",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "3272",
            CompanyName: "HAVELLS INDIA LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "APOLLOTYRE",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "325.65",
            PricePerChange: "-1.07837181044958",
            OIPerChange: "-0.741687979539642",
            SharesRolled: "546000",
            ROPer: "3.8642556353728",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.537386764931675",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "23",
            CompanyName: "APOLLO TYRES LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "GODREJCP",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "909.5",
            PricePerChange: "-1.17353037053134",
            OIPerChange: "2.05704407951599",
            SharesRolled: "71000",
            ROPer: "1.18828451882845",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.65420560747664",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "21960",
            CompanyName: "GODREJ CONSUMER PRODUCTS",
        },
        {
            InstName: "FUTSTK",
            Symbol: "INDUSTOWER",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "185.35",
            PricePerChange: "-1.19936034115139",
            OIPerChange: "3.63847493710083",
            SharesRolled: "571200",
            ROPer: "3.6697247706422",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.350687887779879",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "40279",
            CompanyName: "INDUS TOWERS LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TRENT",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "1235.35",
            PricePerChange: "-1.51080283823647",
            OIPerChange: "2.53707343219582",
            SharesRolled: "60400",
            ROPer: "1.29847794307335",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.805439753915898",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "345",
            CompanyName: "TRENT LTD",
        },
        {
            InstName: "FUTSTK",
            Symbol: "TITAN",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "2509.45",
            PricePerChange: "-1.66539313074316",
            OIPerChange: "9.28069340943925",
            SharesRolled: "193875",
            ROPer: "2.43936963291498",
            RoPer_vs_M1Avg: "0",
            ROCost: "0.793002450736221",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "1016",
            CompanyName: "TITAN COMPANY LIMITED",
        },
        {
            InstName: "FUTSTK",
            Symbol: "IDEA",
            ExpDate: "1/25/2023 12:00:00 AM",
            CurrPrice: "7.35",
            PricePerChange: "-5.76923076923077",
            OIPerChange: "3.8965768390386",
            SharesRolled: "58100000",
            ROPer: "8.84013206944297",
            RoPer_vs_M1Avg: "0",
            ROCost: "1.36054421768708",
            ROCost_vs_M1Avg: "0",
            Mode: "16",
            co_code: "23040",
            CompanyName: "VODAFONE IDEA LIMITED",
        },
    ];
};
